<template>
  <div class="comm_scrInput_wrap">
    <div>
      <sui-text-field
        v-show="!focused"
        ref="userInfo"
        :value="displayName"
        style="width:100%;"
        :readonly="readonly"
        fixedIcon
        :maxlength="maxlength"
        :placeholder="placeholder"
        @focus="onDisplayNameFocus"
        @clear-input="reset"
      />
      <sui-text-field
        v-show="focused"
        ref="inputField"
        v-model="editName"
        style="width:100%;"
        :readonly="readonly"
        fixedIcon
        :maxlength="maxlength"
        :placeholder="placeholder"
        @blur="onInputBlur"
        @keyup.enter="onUserClick"
        @clear-input="resetEditName"
      />
    </div>
    <sui-button
      type="button"
      class="comm_btn_InputScr"
      @click="onUserClick"
    />
  </div>
</template>
<script>
export default {
  name: 'CmpUserMultiSelect',
  props: {
    selectedUsers: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default() {
        return '';
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    checkboxMode: {
      type: Boolean,
      default: true,
    },
    maxlength: {
      type: String,
      default: '100',
    },
  },
  data() {
    return {
      users: this.selectedUsers,
      mode: this.checkboxMode,
      editName: this.selectedUsers.length ? this.selectedUsers[0].userName : '',
      focused: false,
      opened: false,
    };
  },
  computed: {
    displayName() {
      let name = '';
      this.users.forEach((value, index) => {
        if (index === 0) {
          name = value.userName;
        } else {
          name += `, ${value.userName}`;
        }
      });

      return name;
    },
  },
  methods: {
    onUserClick() {
      const userPopupMode = this.checkboxMode;
      const iptUserName = this.editName;

      this.opened = true;
      utils.openLayerPopup('PGE_CMY_00001', this.onUserPopupCallback, {
        // pageInitialData: { iptUserName: iptUserName, userPopupMode: userPopupMode },
        pageInitialData: { iptUserName, userPopupMode },
        size: 'lg',
      });
    },
    onUserPopupCallback(nodeData) {
      if (nodeData) {
        // console.log(nodeData);
        // this.user = nodeData;

        const users = [];
        // let userNameArr = '';
        // console.log(nodeData);
        utils.forEach(nodeData, (value, key) => {
          users.push({
            userName: nodeData[key].userName,
            epId: nodeData[key].epid,
            siteName: nodeData[key].siteName,
            employeeIDNumber: nodeData[key].employeeIDNumber,
            companyName: nodeData[key].companyName,
            departmentName: nodeData[key].departmentName,
            knoxId: nodeData[key].knoxId,
            servedStateCode: nodeData[key].servedStateCode,
            userId: nodeData[key].userId,
            email: nodeData[key].email,
          });
        });
        this.setValue(users);
        this.$emit('selected', this.users);
        this.opened = false;
      }
    },
    setValue(users) {
      this.users = users;
    },
    getValue() {
      return this.users;
    },
    onDisplayNameFocus() {
      this.focused = true;
      this.editName = this.users.length ? this.users[0].userName : '';
      this.$nextTick(() => { this.$refs.inputField.setFocus(); });
    },
    onInputBlur() {
      this.focused = false;
    },
    isPopupOpened() {
      return this.opened;
    },
    reset() {
      this.setValue([]);
      this.$emit('selected', this.users);
    },
    resetEditName() {
      this.editName = '';
    },
  },
};
</script>
<style scoped>
</style>
